import React, { useState, useMemo, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import { Tabs, Tab } from "react-bootstrap";
import VisitDetailsCanvas from "./VisitDetailsCanvas";
import { AgGridReact } from "ag-grid-react";
import CommonPagination from "lib/pagination/CommonPagination";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useWoundManagementHook } from "hooks/woundManagement/useWoundManagementHook";
import { downlaodFiletoType, getFormattedDateTimeWithTimezone } from "utils/functions";
import PropTypes from "prop-types";
import { useProfileHook } from "hooks/profile/useProfileHook";
const VisitDetailsList = ({
  visitData,
  tableColumns,
  gridRef,
  isVisitListUninitialized,
  VisitDataPage,
  updatePage,
  sortData,
  onSortData,
  VisitList,
}) => {
  const [activeTab, setActiveTab] = useState(sessionStorage.getItem("activeTab") || "Needs Review");
  const [showWoundCanvas, setShowWoundCanvas] = useState(false);
  const [showAssessmentCanvas, setShowAssessmentCanvas] = useState(false);
  const [woundDetails, setWoundDetails] = useState([]);
  const [assessmentDetails, setAssessmentDetails] = useState([]);
  const { globalConfigData } = useProfileHook();
  const [patientId, setPatientId] = useState();
  const [woundId, setWoundId] = useState();
  const { woundListing, visitListDownload } = useWoundManagementHook();
  // Handle tab change
  const handleTabSelect = (key) => {
    setActiveTab(key);
    sessionStorage.setItem("activeTab", key);

    // Reset pagination for the new tab
    updatePage(1, 10);
  };

  // Handle canvas transitions
  const handleCanvasTransition = (toAssessment) => {
    setShowWoundCanvas(!toAssessment);
    setShowAssessmentCanvas(toAssessment);
  };
  // Default column definitions
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      resizable: true,
      suppressMovable: false,
    }),
    []
  );

  // Sorting logic
  const onSortChanged = ({ api: { sortController } }) => {
    const sortModel = sortController.getSortModel();
    if (sortModel.length > 0) {
      onSortData(sortModel);
      VisitList();
    } else {
      onSortData([]);
      VisitList("createdAt", "desc");
    }
  };
  const handleDetailsPath = async (data) => {
    setShowWoundCanvas(true);
    setWoundDetails(data);
    setPatientId(data?.woundList?.[0]?.patientId);
    setWoundId(data?._id);
  };
  const fetchWoundDetails = async (woundId) => {
    const result = await woundListing({ woundId });
    setAssessmentDetails(result?.data?.data);
  };
  useEffect(() => {
    if (woundId) {
      fetchWoundDetails(woundId);
    }
  }, [woundId]);

  //Print the Wound Dtails
  const handlePrintWoundDetails = async (woundData) => {
    const result = await visitListDownload({
      patientId: woundData?.woundList?.[0]?.patientId,
      visitDate: woundData?.visitDate,
    });
    if (result?.data?.data) {
      downlaodFiletoType("pdf", result?.data?.data);
    }
  };

  // Updated column definitions
  const column = [
    {
      field: tableColumns && tableColumns[0]?.field,
      headerName: tableColumns && tableColumns[0]?.header,
      hide: tableColumns && !tableColumns[0]?.show,
      flex: 1,
      minWidth: 200,
      sortable: true,
      lockPinned: true,
      unSortIcon: true,
      initialSort: sortData?.current?.[0]?.colId === "visitDate" ? sortData.current?.[0]?.sort : null,
      cellRenderer: function (props) {
        let visitDate = (
          <div className="flex-start-middle text-truncate">
            <span>
              {getFormattedDateTimeWithTimezone(
                props?.data?.visitDate,
                globalConfigData?.data?.timeZone,
                globalConfigData?.data?.dateFormat,
                globalConfigData?.data?.timeFormat,
                false
              )}
            </span>
          </div>
        );
        return visitDate;
      },
    },
    {
      field: tableColumns && tableColumns[1]?.field,
      headerName: tableColumns && tableColumns[1]?.header,
      hide: tableColumns && !tableColumns[1]?.show,
      flex: 1,
      minWidth: 200,
      sortable: true,
      lockPinned: true,
      unSortIcon: true,
      initialSort: sortData?.current?.[1]?.colId === "assessedBy" ? sortData.current?.[1]?.sort : null,
      cellRenderer: function (props) {
        let assessedBy = (
          <div className="flex-start-middle text-truncate">
            <span>{props?.data?.assessedBy ?? "-"}</span>
          </div>
        );
        return assessedBy;
      },
    },
    {
      field: tableColumns && tableColumns[2].field,
      headerName: tableColumns && tableColumns[2].header,
      hide: tableColumns && !tableColumns[2].show,
      flex: 1,
      minWidth: 180,
      lockPinned: true,
      sortable: false,
      cellRenderer: function (props) {
        let adminAction = (
          <div className="flex-start-middle text-truncate h-100">
            {props?.data?.adminAction === "Needs Review" && (
              <div className="badge bg-warning text-white fw-semibold fs-12">{props?.data?.adminAction ?? ""}</div>
            )}{" "}
            {props?.data?.adminAction === "Approved" && (
              <div className="badge secondary-light text-white fw-semibold fs-12">{props?.data?.adminAction ?? ""}</div>
            )}
            {props?.data?.adminAction === "Not Assessed" && (
              <div className="badge bg-danger text-white fw-semibold fs-12">{props?.data?.adminAction ?? ""}</div>
            )}
            {/* <span className="ms-16 text-primary">{props?.data?.tag ?? ""}</span> */}
            {props?.data?.tag == "New" && (
              <div className="ms-8">
                <svg width="35" height="17" viewBox="0 0 35 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M34.5889 13.222L30.509 8.22215L34.5089 3.32231C34.7277 3.05426 34.8655 2.7294 34.9062 2.38581C34.947 2.04222 34.8889 1.69414 34.7389 1.38237C34.5869 1.03292 34.3349 0.736287 34.0146 0.52986C33.6942 0.323433 33.32 0.216454 32.939 0.222407H1.93994C1.68911 0.218437 1.43996 0.263917 1.20672 0.356249C0.973471 0.448582 0.760699 0.585959 0.580553 0.760533C0.400407 0.935108 0.256416 1.14346 0.156803 1.37369C0.0571908 1.60392 0.00390873 1.85152 0 2.10235L0 14.352C0.0105104 14.8568 0.220494 15.3369 0.584031 15.6873C0.947568 16.0377 1.43507 16.2299 1.93994 16.2219H33.0489C33.4172 16.2281 33.7796 16.1287 34.0932 15.9356C34.4068 15.7424 34.6586 15.4636 34.8189 15.1319C34.9628 14.8239 35.0175 14.4817 34.9769 14.1441C34.9362 13.8065 34.8018 13.4871 34.5889 13.222ZM1.99994 14.222V2.22234H32.779L27.9391 8.15216L32.849 14.222H1.99994Z"
                    fill="#EEE417"
                  />
                  <path
                    d="M9.38595 9.57179L6.12606 5.22192H4.99609V11.4017H6.12606V7.06187L9.38595 11.4017H10.5059V5.22192H9.38595V9.57179Z"
                    fill="#EEE417"
                  />
                  <path
                    d="M12.1797 11.4017H16.8395V10.3818H13.3097V8.77181H16.4995V7.74184H13.3097V6.25189H16.8395V5.22192H12.1797V11.4017Z"
                    fill="#EEE417"
                  />
                  <path
                    d="M24.5201 9.65178L23.0601 5.22192H21.8402L20.3702 9.65178L19.0503 5.22192H17.8203L19.7803 11.4017H20.8902L22.4502 6.81187L24.0001 11.4017H25.1301L27.08 5.22192H25.8501L24.5201 9.65178Z"
                    fill="#EEE417"
                  />
                </svg>
              </div>
            )}
            {props?.data?.tag == "Request Closure" && (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.5 3.5C8.5 3.10218 8.65804 2.72064 8.93934 2.43934C9.22064 2.15804 9.60218 2 10 2H14C14.3978 2 14.7794 2.15804 15.0607 2.43934C15.342 2.72064 15.5 3.10218 15.5 3.5H17C17.3978 3.5 17.7794 3.65804 18.0607 3.93934C18.342 4.22064 18.5 4.60218 18.5 5V12.5H17.5V5C17.5 4.86739 17.4473 4.74021 17.3536 4.64645C17.2598 4.55268 17.1326 4.5 17 4.5H15.5C15.5 4.89782 15.342 5.27936 15.0607 5.56066C14.7794 5.84196 14.3978 6 14 6H10C9.60218 6 9.22064 5.84196 8.93934 5.56066C8.65804 5.27936 8.5 4.89782 8.5 4.5H7C6.86739 4.5 6.74021 4.55268 6.64645 4.64645C6.55268 4.74021 6.5 4.86739 6.5 5V19C6.5 19.1326 6.55268 19.2598 6.64645 19.3536C6.74021 19.4473 6.86739 19.5 7 19.5H13V20.5H7C6.60218 20.5 6.22064 20.342 5.93934 20.0607C5.65804 19.7794 5.5 19.3978 5.5 19V5C5.5 4.60218 5.65804 4.22064 5.93934 3.93934C6.22064 3.65804 6.60218 3.5 7 3.5H8.5ZM10 3C9.86739 3 9.74021 3.05268 9.64645 3.14645C9.55268 3.24021 9.5 3.36739 9.5 3.5V4.5C9.5 4.63261 9.55268 4.75979 9.64645 4.85355C9.74021 4.94732 9.86739 5 10 5H14C14.1326 5 14.2598 4.94732 14.3536 4.85355C14.4473 4.75979 14.5 4.63261 14.5 4.5V3.5C14.5 3.36739 14.4473 3.24021 14.3536 3.14645C14.2598 3.05268 14.1326 3 14 3H10ZM11.5 8V9.5H10V10.5H11.5V12H12.5V10.5H14V9.5H12.5V8H11.5ZM14 13.5C13.8674 13.5 13.7402 13.5527 13.6464 13.6464C13.5527 13.7402 13.5 13.8674 13.5 14V17.3945C13.5 17.9707 13.6423 18.5379 13.9142 19.0459C14.186 19.5539 14.5791 19.9869 15.0585 20.3065L16.7225 21.4165C16.8047 21.4713 16.9012 21.5006 17 21.5006C17.0988 21.5006 17.1953 21.4713 17.2775 21.4165L18.9415 20.3065C19.4208 19.9869 19.8139 19.554 20.0857 19.0461C20.3576 18.5382 20.4999 17.9711 20.5 17.395V14C20.5 13.8674 20.4473 13.7402 20.3536 13.6464C20.2598 13.5527 20.1326 13.5 20 13.5H14ZM18.8535 16.3535L16.8535 18.3535C16.7597 18.4472 16.6326 18.4999 16.5 18.4999C16.3674 18.4999 16.2403 18.4472 16.1465 18.3535L15.1465 17.3535L15.8535 16.6465L16.5 17.293L18.1465 15.6465L18.8535 16.3535Z"
                  fill="#6362E6"
                />
              </svg>
            )}
          </div>
        );
        return adminAction;
      },
    },
    {
      field: tableColumns && tableColumns[3].field,
      headerName: tableColumns && tableColumns[3].header,
      hide: tableColumns && !tableColumns[3].show,
      flex: 1,
      minWidth: 180,
      lockPinned: true,
      sortable: false, // Removed sorting for index 3
    },
    {
      field: "action",
      headerName: "Action",
      lockPinned: true,
      suppressMovable: true,
      lockPosition: "right",
      pinned: "right",
      flex: 1,
      width: 110,
      sortable: false, // Removed sorting for action column
      cellRenderer: function (props) {
        return (
          <div className="d-flex align-items-center h-100">
            <a
              onClick={(e) => {
                e.stopPropagation();
                handleDetailsPath(props?.data);
              }}
              className="link-dark blur-content lh-1"
              aria-label="add-role-permissions"
            >
              {props?.data?.woundList?.length > 0 && (
                <OverlayTrigger placement="top" overlay={<Tooltip>View</Tooltip>}>
                  <span className="inic inic-visibility fs-18"></span>
                </OverlayTrigger>
              )}
            </a>
            <a
              onClick={(e) => {
                e.stopPropagation();
                handlePrintWoundDetails(props?.data);
              }}
              className="link-dark blur-content lh-1"
              aria-label="add-role-permissions"
            >
              {props?.data?.woundList?.length > 0 && (
                <OverlayTrigger placement="top" overlay={<Tooltip>Print</Tooltip>}>
                  <span class="inic inic-print ms-8 fs-18"></span>
                </OverlayTrigger>
              )}
            </a>
          </div>
        );
      },
    },
  ];
  function getApprovalStatus(visitData) {
    return visitData?.some((visit) => visit.adminAction === "Needs Review") ? "Needs Review" : "Approved";
  }
  const gridStyle = useMemo(() => ({ width: "100%" }), []);
  return (
    <div>
      <Tabs activeKey={activeTab} id="visitDetailsTabs" onSelect={handleTabSelect}>
        <Tab eventKey="Needs Review" title={`Needs Review (${VisitDataPage?.readOnlyData?.needsReviewCount || ""}) `}>
          <div className="accordion-head">
            <p>Id</p>
            <p>Patient</p>
            <p>App User</p>
            <p>Status</p>
          </div>
          <Accordion className="custom-accordion">
            {visitData?.map((visit) => (
              <Accordion.Item eventKey={visit?.patientId} key={visit?.patientId} className="mt-16">
                <Accordion.Header className="with-multi-text">
                  <p className="patient-id">{visit?.patientBaseId}</p>
                  <p>{visit?.patientName}</p>
                  <p>{visit?.assessedBy}</p>
                  <div className="badge bg-warning text-white fw-bold fs-12">Needs Review</div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="ag-theme-alpine" style={gridStyle}>
                    <AgGridReact
                      ref={gridRef}
                      columnDefs={column}
                      rowData={visit?.visitList}
                      rowSelection="multiple"
                      defaultColDef={defaultColDef}
                      rowClass="clickable-row"
                      onRowClicked={(event) => {
                        // Check if the click is on the action buttons
                        const clickedElement = event.event.target;
                        const isActionButton =
                          clickedElement.closest(".inic-print") || clickedElement.closest(".inic-visibility");

                        // Only call handleDetailsPath if not clicking on action buttons
                        if (!isActionButton) {
                          handleDetailsPath(event.data);
                        }
                      }}
                      suppressRowClickSelection
                      suppressDragLeaveHidesColumns
                      suppressCellFocus
                      onSortChanged={onSortChanged}
                    />
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Tab>
        <Tab eventKey="All" title="All" className="W-25">
          <div className="accordion-head">
            <p>Id</p>
            <p>Patient</p>
            <p>App User</p>
            <p>Status</p>
          </div>
          <Accordion className="custom-accordion">
            {visitData?.map((visit) => (
              <div key={visit?.patientId}>
                <Accordion.Item eventKey={visit?.patientId} key={visit?.patientId} className="mt-16">
                  <Accordion.Header className="with-multi-text">
                    <p className="patient-id">{visit?.patientBaseId}</p>
                    <p>{visit?.patientName}</p>
                    <p>{visit?.assessedBy}</p>
                    <div
                      className={`badge ${
                        getApprovalStatus(visit?.visitList) === "Needs Review" ? "bg-warning" : "secondary-light"
                      } text-white fw-semibold fs-12`}
                    >
                      {getApprovalStatus(visit?.visitList)}
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="ag-theme-alpine" style={gridStyle}>
                      <AgGridReact
                        ref={gridRef}
                        columnDefs={column}
                        rowData={visit?.visitList}
                        rowSelection="multiple"
                        defaultColDef={defaultColDef}
                        suppressRowClickSelection
                        rowClass="clickable-row"
                        onRowClicked={(event) => {
                          const clickedElement = event.event.target;
                          const isActionButton =
                            clickedElement.closest(".inic-print") || clickedElement.closest(".inic-visibility");

                          // Only call handleDetailsPath if not clicking on action buttons
                          if (!isActionButton) {
                            handleDetailsPath(event.data);
                          }
                        }}
                        suppressDragLeaveHidesColumns
                        suppressCellFocus
                        onSortChanged={onSortChanged}
                      />
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </div>
            ))}
          </Accordion>
        </Tab>
      </Tabs>
      {woundDetails && (
        <VisitDetailsCanvas
          type="wound"
          showPermission={showWoundCanvas}
          setShowPermission={setShowWoundCanvas}
          setsWoundId={setWoundId}
          onNavigateToAssessment={() => handleCanvasTransition(true)}
          woundDetailsList={woundDetails}
          PatientDetails={visitData?.find((el) => el.patientId === patientId)}
        />
      )}

      {woundDetails && (
        <VisitDetailsCanvas
          type="assessment"
          showPermission={showAssessmentCanvas}
          setShowPermission={setShowAssessmentCanvas}
          onClose={() => handleCanvasTransition(false)}
          woundDetailsList={assessmentDetails}
          PatientDetails={visitData?.find((el) => el.patientId === patientId)}
        />
      )}
      {!isVisitListUninitialized && (
        <CommonPagination
          updatePage={updatePage}
          total={VisitDataPage?.total || 0}
          className="justify-content-end"
          module="Wound Management"
        />
      )}
    </div>
  );
};

VisitDetailsList.propTypes = {
  gridRef: PropTypes.object.isRequired,
  visitData: PropTypes.array.isRequired,
  tableColumns: PropTypes.array.isRequired,
  isVisitListUninitialized: PropTypes.bool.isRequired,
  VisitDataPage: PropTypes.object.isRequired,
  updatePage: PropTypes.func.isRequired,
  sortData: PropTypes.object.isRequired,
  onSortData: PropTypes.func.isRequired,
  VisitList: PropTypes.func.isRequired,
};

export default VisitDetailsList;
